// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

export const app = initializeApp({
  apiKey: "AIzaSyBKQTb8HYmhCE7sKU7RMHfVSjeOzqQP_Y0",
  authDomain: "yeeeeeeeet-942a7.firebaseapp.com",
  projectId: "yeeeeeeeet-942a7",
  storageBucket: "yeeeeeeeet-942a7.appspot.com",
  messagingSenderId: "968125307153",
  appId: "1:566229235772:web:aeb002d210d61cd93b2b39"
});
